import { useContext } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { RequestAccessAPI } from '../index';
import { directoryType } from '../types';
import { DIRECTORY_TYPE } from '../../constants';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';

const useFetchBusinessLocations = ({
    directoryType = DIRECTORY_TYPE.GOOGLE,
    directoryUserAccountAccountId,
}: {
    directoryType?: directoryType;
    directoryUserAccountAccountId: string;
}) => {
    const { accessId = '' } = useParams();
    const { directoryUserAccountId, directoryUserAccountSecret } =
        useContext(RequestAccessFormContext);

    const {
        data,
        isLoading,
        isFetching,
        isFetchingNextPage,
        isError,
        isFetchNextPageError,
        fetchNextPage,
        hasNextPage,
    } = useInfiniteQuery({
        queryKey: [
            'businessLocations',
            directoryType,
            directoryUserAccountId,
            directoryUserAccountSecret,
            accessId,
            directoryUserAccountAccountId,
        ],
        queryFn: ({ pageParam }) => {
            const params = {
                directoryUserAccountId: String(directoryUserAccountId),
                directoryUserAccountSecret,
                accessRequestFormAccessId: accessId,
                pageToken: String(pageParam),
            };

            return RequestAccessAPI.fetchBusinessLocations(directoryType, directoryUserAccountAccountId, params);
        },
        initialPageParam: '',
        getNextPageParam: (lastPage) => {
            return lastPage.nextPageToken;
        },
    });

    return {
        data,
        isLoading,
        isFetching,
        isFetchingNextPage,
        isError,
        isFetchNextPageError,
        fetchNextPage,
        hasNextPage,
    };
};

export { useFetchBusinessLocations };
